import { forwardRef } from "react";
import type { LucideProps } from "lucide-react";
import nlGridMap from "../../public/nl-grid-map-vectors.json";

/** Same crop as NlGridMap — drops empty canvas above the northern provinces. */
const VIEW_BOX = "0 55 430 605";

export const NlMapIcon = forwardRef<SVGSVGElement, LucideProps>(function NlMapIcon(
  { size = 24, color = "currentColor", className, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={VIEW_BOX}
      fill={color}
      stroke="none"
      className={className}
      aria-hidden
      {...props}
    >
      {nlGridMap.landFill.map((shape) => (
        <path key={shape.id} d={shape.d} fillRule="evenodd" />
      ))}
    </svg>
  );
});
